// Motiv se přepíná atributem data-theme (UI kit ho čte z <body>, vlastní styly z <html>).
import type { Theme } from '@sam/shared';

const KEY = 'sam-theme';

export function resolveTheme(t: Theme): 'light' | 'dark' {
  if (t !== 'auto') return t;
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function applyTheme(t: Theme) {
  try {
    localStorage.setItem(KEY, t);
  } catch {
    /* soukromé okno */
  }
  const r = resolveTheme(t);
  document.documentElement.setAttribute('data-theme', r);
  document.body.setAttribute('data-theme', r);
}

export function storedTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark' || v === 'auto') return v;
  } catch {
    /* soukromé okno */
  }
  return 'auto';
}

/** Při motivu „automaticky“ sledovat změnu systému. */
export function watchSystemTheme(get: () => Theme): () => void {
  const mq = window.matchMedia?.('(prefers-color-scheme: light)');
  if (!mq) return () => {};
  const fn = () => {
    if (get() === 'auto') applyTheme('auto');
  };
  mq.addEventListener('change', fn);
  return () => mq.removeEventListener('change', fn);
}

export const THEME_ORDER: Theme[] = ['auto', 'light', 'dark'];
export const THEME_LABEL: Record<Theme, string> = { auto: 'Automaticky', light: 'Světlý', dark: 'Tmavý' };
